const exerciseLocation = [
    "Gimnasio / Club",
    "Clases en estudio",
    "Casa",
    "Aire libre",
  ];
  export default exerciseLocation;
  